import moment from 'moment-timezone'
const timezone = process.env.TIMEZONE || 'America/Chicago'
moment.tz.setDefault(timezone)
export const nowTz = () => {
  return moment.tz(timezone)
}
export default moment
